<script lang="js">
import { RouterLink } from 'vue-router';
import Swal from 'sweetalert2';
import Dashboard from "../components/AdminDashboard.vue";
import Scholarships from "../components/AdminScholarship.vue";
import Careers from "../components/AdminCareers.vue";
import Settings from "../components/AdminSettings.vue";


export default {
  data() {
    return {
      currentComponent: "Scholarships",
      scholarships: [],
    };
  },
  mounted() {
    this.fetchScholarships();
  },
  methods: {
    fetchScholarships() {
      fetch("https://firstcitypoly.edu.ng/api/get_scholarships.php")
        .then((response) => response.json())
        .then((data) => {
          this.scholarships = data;
        })
        .catch((error) => {
          console.error("Error fetching scholarships:", error);
        });
    },
    rejectScholarship(id) {
      if (id === null || id === undefined || id === "") {
        Swal.fire({
          icon: "error",
          title: "Invalid Scholarship",
          text: "Unable to accept the scholarship because the ID is missing or invalid.",
        });
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to reject this scholarship?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#888",
        confirmButtonText: "Reject it"
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateScholarshipStatus(id, "rejected");
        }
      });
    },

    acceptScholarship(id) {
      if (id === null || id === undefined || id === "") {
        Swal.fire({
          icon: "error",
          title: "Invalid Scholarship",
          text: "Unable to accept the scholarship because the ID is missing or invalid.",
        });
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to accept this scholarship?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#198754",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, accept it!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateScholarshipStatus(id, "accepted");
        }
      });
    },

    updateScholarshipStatus(id, status) {
      fetch(`https://firstcitypoly.edu.ng/api/update_scholarship.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, status }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            Swal.fire({
              icon: "success",
              title: `Scholarship ${status}`,
              text: `This scholarship has been successfully ${status}.`,
              showConfirmButton: false,
              timer: 1500,
            });
            this.fetchScholarships();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Failed to ${status.slice(0, -2)} this scholarship. Please try again.`,
            });
          }
        })
        .catch((error) => {
          console.error(`Error  ${status.slice(0, -2) + `ing`} scholarship:`, error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `Something went wrong while ${status.slice(0, -2) + `ing`}  this scholarship.`,
          });
        });
    },

    logout() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will be logged out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log Out"
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("isLoggedIn");
          this.$router.push({ name: "adminLogin" });

          Swal.fire({
            title: "Logged out!",
            text: "You have been successfully logged out.",
            icon: "success"
          });
        }
      });
    }

  },
  components: {
    RouterLink,
    Dashboard,
    Scholarships,
    Careers,
    Settings,
  },
};
</script>

<template>
  <div class="dashboard-container">
    <!-- Top Navbar -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">FCP Admin</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSidebar"
          aria-controls="offcanvasSidebar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <!-- Sidebar for larger screens -->
        <div class="col-lg-2 d-none d-lg-block bg-light border-end vh-100">
          <div class="sidebar p-3">
            <ul class="nav flex-column text-start">
              <li class="nav-item">
                <a
                  class="nav-link d-flex align-items-center"
                  @click="currentComponent = 'Dashboard'"
                >
                  <i class="bi bi-house-door me-2"></i>
                  Dashboard</a
                >
              </li>
              <li class="nav-item">
                <a
                  @click="currentComponent = 'Scholarships'"
                  class="nav-link d-flex align-items-center"
                >
                  <i class="bi bi-archive me-2"></i>
                  Scholarship Applications
                </a>
              </li>
              <li class="nav-item">
                <a
                  @click="currentComponent = 'Careers'"
                  class="nav-link d-flex align-items-center"
                >
                  <i class="bi bi-file-earmark-person me-2"></i>
                  Careers Applications</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link d-flex align-items-center"
                  @click="currentComponent = 'Settings'"
                >
                  <i class="bi bi-gear me-2"></i>
                  Settings</a
                >
              </li>
              <li class="nav-item">
                <button
                  @click="logout"
                  class="nav-link d-flex align-items-center"
                >
                  <i class="bi bi-box-arrow-in-right me-2"></i>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>

        <!-- Main content -->
        <component :is="currentComponent"></component>
      </div>
    </div>

    <!-- Offcanvas sidebar for mobile -->
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasSidebar"
      aria-labelledby="offcanvasSidebarLabel"
    >
      <div class="offcanvas-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              href="#"
              @click="currentComponent = 'Dashboard'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-house-door me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4z"
                />
              </svg>
              Dashboard</a
            >
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link d-flex align-items-center justify-content-center"
              @click="currentComponent = 'Scholarships'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-archive me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                />
              </svg>
              Scholarship Applications
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              href="#"
              @click="currentComponent = 'Settings'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-gear me-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"
                />
                <path
                  d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"
                />
              </svg>
              Settings</a
            >
          </li>
          <li class="nav-item">
            <button
              @click="logout"
              class="nav-link d-inline-flex align-items-center justify-content-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-box-arrow-in-right me-2"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                />
              </svg>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
